"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dragSource = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDnd = require("react-dnd");

var _classnames = _interopRequireDefault(require("classnames"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));
/**
 * specifies how to handle drag and drop events
 */


var dragSource = {
  beginDrag: function beginDrag(props) {
    props.setResizeMode(true);
    return {
      columnKey: props.columnKey
    };
  },
  endDrag: function endDrag(props) {
    props.setResizeMode(false);
  }
};
/**
 * Specifies the props to inject into your component.
 */

exports.dragSource = dragSource;

var collect = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
};
/**
 * Main Component
 */


var ColumnResizeBar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ColumnResizeBar, _React$Component);

  function ColumnResizeBar() {
    (0, _classCallCheck2.default)(this, ColumnResizeBar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ColumnResizeBar).apply(this, arguments));
  }

  (0, _createClass2.default)(ColumnResizeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      var img = new Image();

      img.onload = function () {
        return _this.props.connectDragPreview(img);
      };

      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.connectDragSource(_react.default.createElement("div", null, _react.default.createElement("div", {
        className: (0, _classnames.default)(_CwDataGrid.default.dndBar, (0, _defineProperty2.default)({}, _CwDataGrid.default.hasFilterTypes, this.props.hasFilterTypes))
      }), this.props.isDragging && _react.default.createElement("div", {
        className: _CwDataGrid.default.resizeGuide,
        style: {
          right: -this.props.hoverOffset.x
        }
      })));
    }
  }]);
  return ColumnResizeBar;
}(_react.default.Component);

ColumnResizeBar.propTypes = {
  columnKey: _propTypes.default.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  hoverOffset: _propTypes.default.object,
  hasFilterTypes: _propTypes.default.bool,
  setResizeMode: _propTypes.default.func,
  // eslint-disable-line react/no-unused-prop-types
  // Injected by React DnD:
  isDragging: _propTypes.default.bool.isRequired,
  connectDragSource: _propTypes.default.func.isRequired,
  connectDragPreview: _propTypes.default.func.isRequired
};
ColumnResizeBar.defaultProps = {
  hoverOffset: {
    x: 0
  },
  hasFilterTypes: false,
  setResizeMode: function setResizeMode() {}
}; // Export the wrapped component:

var _default = (0, _reactDnd.DragSource)('ColumnResizeBar', dragSource, collect)(ColumnResizeBar);

exports.default = _default;